/* eslint-disable no-extra-boolean-cast */


export function toFistCharUpperCase(str:string){
    const strs = str.toLowerCase().split(' ')
    const ret:string[] = [];
    strs.forEach(s => {
        s = s.charAt(0).toUpperCase() + s.slice(1)
        ret.push(s)
    })
    return ret.join(' ');
}

export function removeLeadingZeros(str:string){
    return (str && str.length > 0 && str.replace(/^0+/, '')) || "";
}


/**
 * 
 * @param dt the date to be formatted 
 * @param sep the seperator character. ex: ['','/','-']
 * @returns the date in YYYY$MM$DD format, where $ is the seperator character.
 */
export function formatDate(dt:Date,type:String='YMD',sep:string='-') {
    if(!!!dt){ // return empty string if date is not defined
        return '';
    }
    var d = new Date(dt)
    
    const month = `00${d.getUTCMonth() + 1}`.slice(-2);
    const day = `00${d.getUTCDate()}`.slice(-2);
    const year = d.getUTCFullYear();

    if(type==='MDY'){
        return [month,day, year].join(sep);
    }
    return [year, month, day].join(sep);
  }

  
/**
 * 
 * @param dt the datetime to be formatted 
 * @returns the date in "YYYY-MM-DD hh:mm:ss" format
 */
export function formatDateTime(dt:Date,type:String='YMDhms') {
    if(!!!dt){ // return empty string if date is not defined
        return '';
    }
    var d = new Date(dt)

    const hour = `00${d.getUTCHours()}`.slice(-2);
    const min = `00${d.getUTCMinutes()}`.slice(-2);
    const sec = `00${d.getUTCSeconds()}`.slice(-2);

    if(type === 'hms'){
        return `${[hour, min, sec].join(":")}`;
    }
    return `${formatDate(dt,'YMD','-')} ${[hour, min, sec].join(":")}`;
}


  
export function prettyPrintDollars(value:number){
    return (value).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2})
    // value = Math.round(value*100)/100
    // let ret = ((value<0)?'-':'')+'$';
    // ret += Math.abs(value).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    // return ret
  }

export function tryParseIntOrZero(num:string) {
    let ret = 0;
    try {
        ret = parseInt(num);
    }
    catch (error) { }
    return ret;
}

/**
 *
 * @param stringList an array of stings
 * @returns the stringList with duplicates removed
 */
export function getUniqueStringList(stringList: string[]): string[] {
    const obj: { [key: string]: number } = {};
  
    stringList.forEach((s) => (obj[s] = 1));
    return Object.keys(obj);
  }
  